import { Check, Clock, CornerUpLeft, Undo2, X } from "lucide-react";
import { cn } from "@/lib/utils";

const CLS = {
  pending_recommendation: "bg-amber-50 text-amber-800 border-amber-200", recommended: "bg-sky-50 text-sky-800 border-sky-200",
  pending_approval: "bg-indigo-50 text-indigo-800 border-indigo-200", returned: "bg-orange-50 text-orange-800 border-orange-200",
  approved: "bg-emerald-50 text-emerald-800 border-emerald-200", rejected: "bg-red-50 text-red-700 border-red-200", withdrawn: "bg-slate-100 text-slate-500 border-slate-200",
};
const ICON = { approved: Check, rejected: X, returned: CornerUpLeft, withdrawn: Undo2 };

export const ApprovalStatus = ({ r, testid }) => {
  const Icon = ICON[r.status] || Clock;
  return (
    <span className={cn("inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold", CLS[r.status])} data-testid={testid}>
      <Icon className="h-3 w-3" /> {r.status_label}
    </span>
  );
};

export const STATUS_OPTIONS = [["pending_recommendation", "Pending Recommendation"], ["recommended", "Recommended"], ["pending_approval", "Pending Approval"],
  ["returned", "Returned"], ["approved", "Approved"], ["rejected", "Rejected"], ["withdrawn", "Withdrawn"]];
